import axios from "axios";
import { PUBLIC_TOKEN_HEADER, getPublicToken, refreshPublicToken } from "./helpers/public-session";

const PUBLIC_TOKEN_REQUIRED = "PUBLIC_TOKEN_REQUIRED";
const ABSOLUTE_URL = /^([a-z][a-z\d+\-.]*:)?\/\//i;

// The token is only meant for our own API. Sending a custom header anywhere
// else would also turn those calls into CORS preflights the other side rejects.
function isApiRequest(config) {
  const apiBase = process.env.VUE_APP_SMEGP_BASE_API;
  const url = config.url || "";
  const target = ABSOLUTE_URL.test(url) ? url : config.baseURL || "";
  return !!apiBase && target.indexOf(apiBase) === 0;
}

// The API decides which endpoints need a public session and says so with
// 401 PUBLIC_TOKEN_REQUIRED. Nothing happens here until it does, so this is
// inert against an API that does not enforce the guard.
export function publicSessionInterceptor() {
  axios.interceptors.request.use((config) => {
    const token = isApiRequest(config) && getPublicToken();
    if (token) config.headers[PUBLIC_TOKEN_HEADER] = token;
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error && error.config;
      const response = error && error.response;

      if (
        !config ||
        !response ||
        response.status !== 401 ||
        !response.data ||
        response.data.type !== PUBLIC_TOKEN_REQUIRED ||
        config._publicSessionRetry
      ) {
        return Promise.reject(error);
      }
      config._publicSessionRetry = true;

      try {
        // Another request may have renewed the session while this one was in
        // flight; reuse that token rather than running a second challenge.
        const current = getPublicToken();
        const sent = config.headers[PUBLIC_TOKEN_HEADER];
        config.headers[PUBLIC_TOKEN_HEADER] = current && current !== sent ? current : await refreshPublicToken();
      } catch (challengeError) {
        return Promise.reject(error);
      }
      return axios(config);
    }
  );
}
